import React from 'react';
import { Box } from '@spothero/ui';
import { RatingDistributionBar } from './RatingDistributionBar';
import { computeStarDistribution, hasStarDistributionData, } from './utils/star-utils';
export const RatingDistributionList = ({ ratingInfo, }) => {
    if (!hasStarDistributionData(ratingInfo)) {
        return null;
    }
    const distribution = computeStarDistribution(ratingInfo);
    return (<Box marginTop={3} marginBottom={3} data-testid="RatingDistributionList">
            {distribution.map(item => (<RatingDistributionBar key={item.label} label={item.label} percentage={item.percentage}/>))}
        </Box>);
};
